<ng-template
  [cdkConnectedOverlayOrigin]="overlayOrigin()"
  [cdkConnectedOverlayOpen]="showOverlay()"
  (overlayKeydown)="overlayKeydown($event)"
  cdkConnectedOverlayPanelClass="flx-overlay"
  cdkConnectedOverlay
>
  <div
    [class]="origin()"
    (click)="onFakeBackdropClick()"
    class="overlay-content absolute w-full bg-gray-800 bg-opacity-50 ease-in-out duration-300"
  >
    @if (dismissible()) {
      <button
        (click)="showOverlay.set(false)"
        class="z-50 p-0 text-neutral-900 relative right-0 top-12 left-[calc(100%-2rem)]"
        data-testid="overlay-close-button"
        flxButton
        icon="center"
        variant="text"
      >
        <i
          class="ph ph-x text-lg"
          flxIcon
        ></i>
      </button>
    }

    <ng-content></ng-content>
  </div>
</ng-template>
